import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'privacy-policy-suidpunt',
  templateUrl: './privacy-policy-suidpunt.component.html',
  styleUrls: ['./privacy-policy-suidpunt.component.scss'],
})
export class PrivacyPolicySuidpunt implements OnInit {
  constructor() { }

  ngOnInit() {
  }
}
